import { render, staticRenderFns } from "./OpinionAliasAdd.vue?vue&type=template&id=e377ba3c&scoped=true"
import script from "./OpinionAliasAdd.vue?vue&type=script&lang=js"
export * from "./OpinionAliasAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e377ba3c",
  null
  
)

export default component.exports